import {
  OrganizationFacilitiesIncidentCountQuery,
  OrganizationFacilitiesQuery,
} from '@/graphql/generated/operations'
import { mixpanel } from '@/utils/analytics'

export const trackOrganisationInfo = (
  facilitiesData: OrganizationFacilitiesQuery,
  facilitiesIncidentCountData: OrganizationFacilitiesIncidentCountQuery
) => {
  // Total incidents for all the facilities
  const numberOfIncidents =
    facilitiesIncidentCountData?.facilities?.edges?.reduce(
      (n, { node }) => n + node.incidents?.totalCount,
      0
    )
  mixpanel.track('Page Load: Global Map View', {
    number_of_incidents: numberOfIncidents,
    number_of_facilities: facilitiesData?.facilities?.edges?.length,
  })
}
